export default __webpack_public_path__ + "5c611744e10577f1a07bc4b0c07feba8.png";